import api from '@/api/api'

const state = {
  data: {},
  name: '',
  listData: [],
  listTotal: 0,
  listHeader: [],
}

const mutations = {
  CLEAR_DOCUMENTS: state => {
    state.listData = []
  },

  GET_DOCUMENTS: (state, response) => {
    state.listData = Object.values(response.data)
    state.listTotal = response.headers['x-total-count']
  },

  GET_DOCUMENTS_HEADER: (state, data) => {
    state.listHeader = data
  },

  GET_DOCUMENT: (state, data) => {
    state.data = data.data
    state.name = data.name
  },

  CLEAR_DOCUMENT: state => {
    state.data = {}
    state.name = ''
  },
}

const actions = {
  getDocuments: ({ commit, rootState }, params) => {
    return new Promise((resolve, reject) => {
      commit('CLEAR_DOCUMENTS')
      api
        .getDocuments({ ...params, userId: rootState.user.id })
        .then(response => {
          commit('GET_DOCUMENTS', response)
          resolve(response)
        })
        .catch(error => {
          reject(error)
          console.log(error)
        })
    })
  },

  getDocumentsHeader: ({ commit }) => {
    return new Promise((resolve, reject) => {
      api
        .getTemplatesHeader()
        .then(response => {
          commit('GET_DOCUMENTS_HEADER', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
          console.log(error)
        })
    })
  },

  clearDocument: ({ commit }) => {
    return new Promise(resolve => {
      commit('CLEAR_DOCUMENT')
      resolve()
    })
  },

  generateDocument: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      api
        .generateDocument(data)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
          console.error(err)
        })
    })
  },

  getDocument: ({ commit }, id) => {
    return new Promise((resolve, reject) => {
      api
        .getDocument(id)
        .then(response => {
          commit('GET_DOCUMENT', response.data)
          resolve(response)
        })
        .catch(err => {
          reject(err)
          console.error(err)
        })
    })
  },

  postDocument: ({ rootState }, data) => {
    const postData = {
      ...data,
      date: new Date(),
    }
    return new Promise((resolve, reject) => {
      api
        .postDocument(postData)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
          console.error(err)
        })
    })
  },

  patchDocument: ({ commit }, patchData) => {
    const { id, data } = patchData
    return new Promise((resolve, reject) => {
      api
        .patchDocument(id, data)
        .then(response => {
          commit('GET_DOCUMENT', response.data)
          resolve(response)
        })
        .catch(err => {
          reject(err)
          console.error(err)
        })
    })
  },

  deleteDocument: ({ commit }, id) => {
    return new Promise((resolve, reject) => {
      api
        .deleteDocument(id)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
          console.error(err)
        })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
